import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API;

const ConfirmActivation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const uid = searchParams.get("uid");
  const token = searchParams.get("token");

  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  // If uid or token are missing, show error immediately
  useEffect(() => {
    if (!uid || !token) {
      setStatus("error");
      setMessage("הקישור אינו תקין. נא בקש קישור הפעלה חדש.");
    }
  }, [uid, token]);

  const handleActivate = async () => {
    setStatus("loading");
    try {
      await axios.post(
        `${BASE_URL}accounts/activate/${uid}/${token}`, // ✅ matches your Django URL
        {},
      );

      setStatus("success");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setStatus("error");
      const detail = err.response?.data?.detail;
      setMessage(detail || "ההפעלה נכשלה. הקישור אינו תקין או פג תוקף.");
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div
        className="card shadow p-5 text-center"
        style={{ maxWidth: 460, width: "100%" }}
      >
        {/* Idle — waiting for user to click */}
        {status === "idle" && (
          <>
            <div className="mb-4">
              <span style={{ fontSize: 56 }}>✉️</span>
            </div>
            <h3 className="fw-bold mb-2">אימות החשבון</h3>
            <p className="text-muted mb-4">
              לחץ על הכפתור למטה כדי להפעיל את חשבונך ולהתחיל להשתמש במערכת.
            </p>
            <button
              className="btn btn-primary btn-lg w-100"
              onClick={handleActivate}
            >
              הפעל את החשבון שלי
            </button>
          </>
        )}

        {/* Loading */}
        {status === "loading" && (
          <>
            <div className="mb-4">
              <div
                className="spinner-border text-primary"
                style={{ width: 56, height: 56 }}
                role="status"
              />
            </div>
            <h3 className="fw-bold mb-2">מפעיל את החשבון...</h3>
            <p className="text-muted">אנא המתן רגע.</p>
          </>
        )}

        {/* Success */}
        {status === "success" && (
          <>
            <div className="mb-4">
              <span style={{ fontSize: 56 }}>✅</span>
            </div>
            <h3 className="fw-bold mb-2 text-success">החשבון הופעל בהצלחה!</h3>
            <p className="text-muted mb-4">
              מועבר לדף ההתחברות תוך מספר שניות...
            </p>
            <button
              className="btn btn-success w-100"
              onClick={() => navigate("/login")}
            >
              התחבר עכשיו
            </button>
          </>
        )}

        {/* Error */}
        {status === "error" && (
          <>
            <div className="mb-4">
              <span style={{ fontSize: 56 }}>❌</span>
            </div>
            <h3 className="fw-bold mb-2 text-danger">ההפעלה נכשלה</h3>
            <p className="text-muted mb-4">{message}</p>
            <button
              className="btn btn-outline-primary w-100"
              onClick={() => navigate("/register")}
            >
              חזור להרשמה
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmActivation;
